/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { TemplateCellContainer } from "./TemplateCellContainer";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateHeaderCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateHeaderCell, _super);
    function TemplateHeaderCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b3 = null;
        _this.b3 = new TemplateCellContainer(a);
        _this.z.append(_this.b3.element);
        return _this;
    }
    Object.defineProperty(TemplateHeaderCell.prototype, "b4", {
        get: function () {
            return this.b3;
        },
        enumerable: true,
        configurable: true
    });
    TemplateHeaderCell.prototype.get_q = function () {
        return true;
    };
    TemplateHeaderCell.$t = markType(TemplateHeaderCell, 'TemplateHeaderCell', GridCellBase.$);
    return TemplateHeaderCell;
}(GridCellBase));
export { TemplateHeaderCell };
//# sourceMappingURL=TemplateHeaderCell.js.map
